export default __webpack_public_path__ + "static/media/CBS_news_logo.5a306a24.png";